import React from 'react'
import { Layer, Image as ImageKonva } from 'react-konva'

interface ImageLayersProps {
    beforeImageRef: HTMLImageElement
    afterImageRef: HTMLImageElement
    width: number
    height: number
}

/**
 * Before/After画像を表示するレイヤー
 * Before画像（背景）とAfter画像（上層）を重ねて表示
 */
export const ImageLayers: React.FC<ImageLayersProps> = ({ beforeImageRef, afterImageRef, width, height }) => {
    return (
        <>
            <Layer>
                <ImageKonva image={beforeImageRef} width={width} height={height} />
            </Layer>
            <Layer>
                <ImageKonva image={afterImageRef} width={width} height={height} />
            </Layer>
        </>
    )
}
